import RestService from 'restService';
import Submission from './Submission';
import Manager from '../../../../core/Manager';
import Account from '../../../../core/Account';

export default class SubmissionCollection {
  list: any = [];

  add(submission: Submission): Promise<void> {
    return Promise.resolve();
  }

  async load(): Promise<void> {
    let response = await RestService.get('submissions');
    this.list = [];
    response.data.forEach((item) => {
      const submission = new Submission();
      submission.id = item.id;
      submission.name = item.name;
      submission.percentComplete = item.percentComplete;
      submission.sharedWith = item.users.map((user) => new Account(user));
      submission.sharedWith.forEach(async (account: Account) => await account.load());
      this.list.push(submission);
    });
  }

  async delete(id: string): Promise<void> {
    let response = await RestService.delete(`submission/${id}`);
  }
}
